import React from 'react';
import { BaseConfig } from '../BaseConfig';
import ContinueButton from './ContinueButton';
import { UIProperties } from '../UIProperties';

import './RememberUI.css'

const RememberUI = (props: UIProperties<RememberUIConfig>) => {
	return (
		<div id={props.id} className="in-game-ui-container ui-top-most-container modal-bg dialogueui-container rem-fade-in modal-disable-select">
			<div className="remember-container center-on-container">
				<img src="./assets/images/general/backgrounds/modal.png"/>
				<p id='first-object-remember' tabIndex={0} aria-Label='Remember to' className="modal-title remember-font">REMEMBER TO:</p>
				<div className="remember-desc-container">
					<div  style={{
						width: '100%',
						position: 'absolute',
						height: '286px',
						top: '83px',
						transform: 'translate(-50%, 0)',
						left: '50%',
						padding: '20px',
						paddingLeft: '60px',
    					paddingRight: '60px'
					}}>
						<p tabIndex={0} className="remember-desc regular-description-font" style={{
						}}>1. Maintain hand hygiene</p>
						<p tabIndex={0} className="remember-desc regular-description-font" style={{
						}}>2. Introduce yourself</p>
						<p tabIndex={0} className="remember-desc regular-description-font" style={{
						}}>3. Verify identity</p>
						<p tabIndex={0} className="remember-desc regular-description-font" style={{
						}}>4. Write you name on the whiteboard</p>
						<ContinueButton parameters= {{
							id:'last-object-remember',
							top: '209px',
							left: '250px',
							width: '150px',
							highlightOnHover: true,
							onClicked: () => {
								var el = document.getElementById(props.id);
								el.classList.remove('rem-fade-in');
								el.classList.add('rem-fade-out');
								setTimeout(() => {
									props.parameters.onContinueClicked();
								}, 1000);
							}
						}}/>
					</div>
				</div>
			</div>
		</div>
	);

};

export interface RememberUIConfig extends BaseConfig {
	onContinueClicked: () => void;
}

export default RememberUI;